module.exports = __webpack_public_path__ + "static/media/React.3d615d30.png";